import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  children: PropTypes.node,
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  textSize: PropTypes.oneOf(['small', 'regular']),
  numberOfLines: PropTypes.oneOf(['auto', 1, 2]),
};
const defaultProps = {
  verticalAlign: 'middle',
  textAlign: 'left',
  textSize: 'regular',
  numberOfLines: 'auto',
};

const TBody = styled.tbody`
  vertical-align: ${({ verticalAlign }) => verticalAlign};
  text-align: ${({ textAlign }) => textAlign};
  font-size: ${({ textSize }) => (textSize === 'small' ? '0.875rem' : '1rem')};
  td > div {
    -webkit-line-clamp: ${({ numberOfLines }) => numberOfLines};
    height: 100%;
    min-height: ${({ numberOfLines }) => ('auto' ?? numberOfLines === 1 ? '22px' : '44px')};
  }
`;

const TableBody = (props) => {
  const {
    children,
    verticalAlign,
    textAlign,
    textSize,
    numberOfLines,
  } = props;

  return (
    <TBody
      verticalAlign={verticalAlign}
      textAlign={textAlign}
      textSize={textSize}
      numberOfLines={numberOfLines}
    >
      {children}
    </TBody>
  );
};

TableBody.propTypes = propTypes;
TableBody.defaultProps = defaultProps;

export default TableBody;
